import React,{ useEffect, useState } from 'react';
// import videoAccountQrcode from '@/assets/video_account_qrcode.jpg';
import qcvBg from '@/assets/qcv_bg.jpg';
import qcvCenter from '@/assets/qcv_center.jpg';

export default (props) => {
  return (
    <div style={{
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${qcvBg})`,
      textAlign: 'center',
      width: '100%',
      height: '100vh',
      backgroundSize: '100% 100%',
      overflow: 'hidden'
    }}>
      <img style={{width: '70%', marginTop: '35%', marginLeft: 'auto', marginRight: 'auto'}} src={qcvCenter} />
    </div>
  )
}
